import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Icons } from "prefab";
import Collapsible from "../../../../common/Collapsible";
import { formatValidityPeriod } from "../../../../../utils";
import CampaignTree from "../../CampaignStructure/CampaignTree";
import styles from "../../../../../styles/Campaigns/Campaigns.module.scss";
import Popup from "../../../../common/Popup";
import PageLoadingWithTable from "../../../../common/PageLoadingWithTable";
import InfoBlockLoading from "../../../../common/InfoBlockLoading";
import getSummaryBlock from "../../utils/getSummaryBlock";
import LocalizedButton from "../../../../common/LocalizedButton";
import CriteriaList from "../CriteriaList";
import { getCampaignTree as getCampaignTreeApi } from "../../../../../api";
import { CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST, CAMPAIGN_ACTIONS } from "../../../../../constants";

const {
  EditIcon,
  DeleteIcon,
  CopyIcon,
  ChevronDownIcon,
  LocationIcon,
  TheatreIcon,
  AddIcon,
} = Icons;

export default class TargetGroupDetails extends Component {
  static propTypes = {
    targetGroups: PropTypes.array.isRequired,
    withCampaignTree: PropTypes.bool,
    showEstimates: PropTypes.bool,
    showAdd: PropTypes.bool,
    showEdit: PropTypes.bool,
    showDuplicate: PropTypes.bool,
    showDelete: PropTypes.bool,
  };

  static defaultProps = {
    showAdd: false,
    showEstimates: false,
    withCampaignTree: false,
    showEdit: true,
    showDuplicate: true,
    showDelete: true,
  };

  state = {
    isPopupOpen: false,
    isCampaignStructureLoading: true,
    campaignStructure: {},
    isCampaignStructureError: false,
  };

  componentDidMount = async () => {
    if (this.props.withCampaignTree) await this.fetchCampaignTreeData();
  };

  fetchCampaignTreeData = () => {
    const { params } = this.props;

    getCampaignTreeApi(params.campaignId)
      .then((campaignRes) =>
        this.setState({
          isCampaignStructureLoading: false,
          campaignStructure: campaignRes,
        })
      )
      .catch((err) => {
        this.setState({
          isCampaignStructureLoading: false,
          isCampaignStructureError: true,
          campaignStructure: null,
        });
      });
  };

  handleEditClick = (event, id) => {
    event.stopPropagation();
    if (this.props.onEdit) {
      this.props.onEdit(id);
    }
  };

  handleDuplicateClick = (event, id) => {
    event.stopPropagation();
    if (this.props.onDuplicate) {
      this.props.onDuplicate(id);
    }
  };

  handleTargetGroupCreate = (event) => {
    event.stopPropagation();
    if (this.props.onTargetGroupCreate) {
      this.props.onTargetGroupCreate();
    }
  };

  handleConfirmDelete = (event) => {
    event.stopPropagation();
    if (this.props.onDelete) {
      this.props.onDelete(this.state.selectedId);
    }

    this.setState({
      isPopupOpen: false,
    });
  };

  handleDeleteClick = (event, id) => {
    event.stopPropagation();

    this.setState({
      isPopupOpen: true,
      selectedId: id,
    });
  };

  onDiscardChanges = (event) => {
    event.stopPropagation();

    this.setState({
      isPopupOpen: false,
    });
  };

  renderTargetGroupsCriteria = (targetGroup) => {
    const { showEstimates, countries, isDetailsLoading } = this.props;
    if (isDetailsLoading) {
      return (
        <div className={styles.collapsibleBodyContainer}>
          <InfoBlockLoading />;
        </div>
      );
    }

    if (!targetGroup.criteria) {
      return <div className={styles.collapsibleBodyContainer}>No Criteria Found</div>;
    }

    return (
      <div className={styles.collapsibleBodyContainer}>
        {showEstimates && getSummaryBlock(targetGroup)}
        <div className={styles.criteriaContainer}>
          <CriteriaList
            targetGroupType="theatre"
            criteria={targetGroup?.criteria}
            headerIcon={<TheatreIcon />}
            countries={countries}
            headerName="Theatre"
            withEdit={false}
          />
          <CriteriaList
            targetGroupType="location"
            criteria={targetGroup?.criteria}
            headerIcon={<LocationIcon />}
            countries={countries}
            headerName="Location"
            withEdit={false}
          />
        </div>
      </div>
    );
  };

  render() {
    const {
      targetGroups,
      showDelete,
      showDuplicate,
      showEdit,
      showAdd,
      withCampaignTree,
      isLoading,
    } = this.props;
    const {
      isPopupOpen,
      isCampaignStructureLoading,
      campaignStructure,
      isCampaignStructureError,
    } = this.state;

    if (isLoading) return <PageLoadingWithTable />;

    return (
      <>
        <div className="col-12 clearfix flex">
          <div className="col-12">
            {targetGroups.map((targetGroup, index) => (
              <Collapsible
                key={index}
                className="col-12 flex flex-column"
                header={(isOpen, toggleCollapse) => (
                  <div
                    className={styles.collapsibleHeaderContainer}
                    onClick={() => {
                      this.props.getTargetGroupDetails(targetGroup.id, "list");
                      toggleCollapse();
                    }}
                  >
                    <div className={styles.title}>
                      <span
                        className={classNames(styles.icon, {
                          [styles.open]: isOpen,
                          [styles.close]: !isOpen,
                        })}
                      >
                        <ChevronDownIcon />
                      </span>
                      {`${targetGroup.name} ${targetGroup.code ? `(${targetGroup.code})` : ""}`}
                    </div>
                    <div className={styles.subTitle}>
                      <div className={styles.info}>
                        {formatValidityPeriod(targetGroup?.validity)}
                      </div>
                    </div>
                    <div className={styles.collapseActions}>
                      {showEdit &&
                        CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[CAMPAIGN_ACTIONS.EDIT].includes(
                          targetGroup.status
                        ) && (
                          <div
                            className={styles.button}
                            onClick={(event) => this.handleEditClick(event, targetGroup.id)}
                          >
                            <EditIcon />
                          </div>
                        )}
                      {showDuplicate && (
                        <div
                          className={styles.button}
                          onClick={(event) => this.handleDuplicateClick(event, targetGroup.id)}
                        >
                          <CopyIcon />
                        </div>
                      )}
                      {showDelete && (
                        <div
                          className={styles.button}
                          onClick={(event) => this.handleDeleteClick(event, targetGroup.id)}
                        >
                          <DeleteIcon />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                body={() => this.renderTargetGroupsCriteria(targetGroup)}
              />
            ))}
            {showAdd && (
              <LocalizedButton
                minimal
                text="Button.createTargetGroup"
                icon={<AddIcon width={16} height={16} />}
                onClick={this.handleTargetGroupCreate}
                className={`${styles.button} ${styles.createButton}`}
              />
            )}
          </div>
          {withCampaignTree && !isCampaignStructureError && (
            <div className={styles.campaignTree}>
              <CampaignTree
                isLoading={isCampaignStructureLoading}
                campaignTreeData={campaignStructure ?? []}
              />
            </div>
          )}
        </div>
        <Popup
          isOpen={isPopupOpen}
          onClose={this.onDiscardChanges}
          onConfirm={this.handleConfirmDelete}
          title="Popup.title"
          body="Popup.body"
        />
      </>
    );
  }
}
